import { render, staticRenderFns } from "./orgNotificationFromEmailLink.vue?vue&type=template&id=268ca092&"
import script from "./orgNotificationFromEmailLink.vue?vue&type=script&lang=js&"
export * from "./orgNotificationFromEmailLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports